/**
 *
 * @param {Array<{dr: number, cr: number, jStatus: 0|1|2|3}>} ledger
 * @returns {number}
 */
function computeLoanBalance(ledger) {
  let dr = 0,
    cr = 0;

  for (const entry of ledger) {
    if (entry.jStatus !== 1) continue;

    dr += entry.dr;
    cr += entry.cr;
  }

  return dr - cr;
}

export default computeLoanBalance;
